<template>
  <div class="kaer-page">
    <kaer-header
      v-if="showHeader && computedShow"
      :headerConfig="props.headerConfig"
      :opacity="opacity"
      :customBack="customBack"
      @goBack="$emit('goBack')"
    />
    <div
      class="kaer-page-container"
      :style="{
        paddingTop: props.headerConfig && props.headerConfig.immersion
          ? 0
          : computedShow
            ? px2rem(headerPaddingTop)
            : 0,
        backgroundColor: props.backgroundColor || undefined,
        backgroundImage: props.backgroundImage
          ? `url(${props.backgroundImage})`
          : undefined,
      }"
      >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import KaerHeader from '../header';

export default {
  name: 'kaer-page',
  components: {
    KaerHeader
  },
  props: {
    type: String,
    props: Object,
    customBack: Boolean
  },
  data() {
    return {
      showHeader: false,
      opacity: 0
    };
  },
  watch: {
    props(val) {
      // 获取到props后再显示header
      this.checkShowHeader(val);
    }
  },
  computed: {
    headerPaddingTop() {
      return this.adapt.getPaddingTop() + 44;
    },
    computedShow() {
      const headerConfig = this.props.headerConfig || {};
      switch (true) {
        case this.isMock:
          return headerConfig.navEnvs?.length;
        case this.env.inAPP:
          return headerConfig.navEnvs?.includes('app');
        case this.env.inWechat:
          return headerConfig.navEnvs?.includes('wechat');
        case this.env.inWechatMiniProgram:
          return headerConfig.navEnvs?.includes('miniprogram');
        default:
          return headerConfig.navEnvs?.includes('browser');
      }
    }
  },
  mounted() {
    this.checkShowHeader(this.props);
    window.addEventListener('scroll', this.onScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    checkShowHeader(val) {
      if (val) this.showHeader = true;
    },
    onScroll(e) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.opacity = scrollTop / 88;
    }
  }
};
</script>

<style lang="scss" scoped>
.kaer-page-container {
  background-size: 100%;
  background-repeat: no-repeat;
}
</style>
